module.exports = __webpack_public_path__ + "c28ba89cb7bae3fde63118fa1ed862c5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/candy.png
// module id = 2374
// module chunks = 0